import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import axios from '../axios'; // your configured axios (baseURL + withCredentials)

const ChangePassword = () => {
  const [userId, setUserId] = useState(null);

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(null);        // success/info
  const [error, setError] = useState(null);            // error text

  // Get current user (Sanctum: /api/user; with axios baseURL likely '/api')
  useEffect(() => {
    let active = true;
    const fetchMe = async () => {
      try {
        const { data } = await axios.get('/user'); // must return { id, ... }
        if (active) setUserId(data?.id);
      } catch (e) {
        // If this fails, make sure you're authenticated and CORS/CSRF are set up
        setError('Unable to load current user. Please log in again.');
      }
    };
    fetchMe();
    return () => { active = false; };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    if (!userId) {
      setError('User not loaded. Please refresh and try again.');
      return;
    }
    if (!currentPassword || !newPassword || !confirmNewPassword) {
      setError('Please fill in all fields.');
      return;
    }
    if (newPassword.length < 8) {
      setError('New password must be at least 8 characters.');
      return;
    }
    if (newPassword !== confirmNewPassword) {
      setError('New password and confirmation do not match.');
      return;
    }

    try {
      setSubmitting(true);
      await axios.post(`/users/${userId}/change-password`, {
        current_password: currentPassword,
        new_password: newPassword,
        new_password_confirmation: confirmNewPassword,
      });
      setMessage('Password updated successfully.');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmNewPassword('');
    } catch (err) {
      // Try to surface Laravel validation messages
      const apiMsg =
        err?.response?.data?.message ||
        err?.response?.data?.errors?.current_password?.[0] ||
        'Failed to update password.';
      setError(apiMsg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout>
      <div className="container page-wrap" style={{ maxWidth: 640 }}>
        <h2>Change Password</h2>

        {message && (
          <div className="alert alert-success mt-3" role="alert">
            {message}
          </div>
        )}
        {error && (
          <div className="alert alert-danger mt-3" role="alert">
            {error}
          </div>
        )}

        <form className="mt-4 folder-form" onSubmit={handleSubmit} autoComplete="off">
          <div className="mb-3">
            <label className="form-label">Current Password</label>
            <input
              type="password"
              className="form-control"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Enter current password"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">New Password</label>
            <input
              type="password"
              className="form-control"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="At least 8 characters"
              required
              minLength={8}
            />
            <small className="text-muted">
              Use at least 8 characters. A mix of letters, numbers, and symbols is recommended.
            </small>
          </div>

          <div className="mb-4">
            <label className="form-label">Confirm New Password</label>
            <input
              type="password"
              className="form-control"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              placeholder="Re-enter new password"
              required
              minLength={8}
            />
          </div>

          <button className="btn btn-primary" type="submit" disabled={submitting || !userId}>
            {submitting ? 'Updating...' : 'Update Password'}
          </button>
        </form>
      </div>
    </Layout>
  );
};

export default ChangePassword;
